export default {
  PHONE_NUMBER: 'Phone number must be valid',
  MESSAGE: 'Message must not contain disallowed characters',
};
